"use strict";
/**
 * @module Services.GatewayControl
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../../io/codec");
var serialiser_1 = require("./../../../serialisers/serialiser");
/**
 * Serialiser for {@link GatewayOperation} (non-detailed).
 */
var GatewayOperationSerialiserClass = /** @class */ (function (_super) {
    __extends(GatewayOperationSerialiserClass, _super);
    function GatewayOperationSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link GatewayOperation} from the stream
     *
     * @param bis the input stream
     * @return    the {@link GatewayOperation} that was read
     */
    GatewayOperationSerialiserClass.prototype.read = function (bis) {
        var name = Codec.readString(bis);
        var summary = Codec.readString(bis);
        return {
            name: name,
            summary: summary
        };
    };
    /**
     * Write a {@link GatewayOperation} from the stream
     *
     * @param bos   the output stream
     * @param value the {@link GatewayOperation} to write
     */
    GatewayOperationSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeString(bos, value.summary);
    };
    return GatewayOperationSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.GatewayOperationSerialiserClass = GatewayOperationSerialiserClass;
/**
 * The {@link GatewayOperationSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.GatewayOperationSerialiser = new GatewayOperationSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/operations/operation-serialiser.js
// module id = 1573
// module chunks = 1